import React, { useContext } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { Container, Row, Col, Navbar, Nav, Tabs, Tab } from 'react-bootstrap';
import TopBanner from '../../components/topBanner';
import BottomBanner from '../../components/bottomBanner';
import ContactBanner from '../../components/contactBanner/ContactBanner';
import DomainSearchForm from '../../components/domainSearchForm';
import { domainPrices, webHostingPlans, emailPlans, vpsPlans } from '../../resources/static/index';
import getCurrencySign from '../../utils/getCurrencySign';
import { CurrencyContext } from '../../utils/currencyContext';
import webIcon from '../../assets/img/web-icon.svg';
import emailIcon from '../../assets/img/email-icon.svg';
import vpsIcon from '../../assets/img/vps-icon.svg';
import infoIcon1 from '../../assets/img/info-icon-1.svg';
import infoIcon2 from '../../assets/img/info-icon-2.svg';
import infoIcon3 from '../../assets/img/info-icon-3.svg';
import infoIcon4 from '../../assets/img/info-icon-4.svg';
import infoIcon5 from '../../assets/img/info-icon-5.svg';
import infoIcon6 from '../../assets/img/info-icon-6.svg';
import migrationIcon from '../../assets/img/icon-migration.svg';
import transferDomainIcon from '../../assets/img/icon-transferdom.svg';
import releaseIcon from '../../assets/img/release-icon.svg';
import startIcon from '../../assets/img/star-orange.svg';
import checkmarkIcon from '../../assets/img/checkmark.svg';
import topBanner from '../../assets/img/home-banner.svg';
import { SmoothScrollLink } from '../../utils/navUtils';
import localizedPath from '../../utils/localization';
import './home.scss';

function HomePage() {
    const { t } = useTranslation();
    const { currentCurrency } = useContext(CurrencyContext);
    const sign = getCurrencySign(currentCurrency);
    const domainData = domainPrices[currentCurrency];
    const hostingData = webHostingPlans[currentCurrency];
    const emailData = emailPlans[currentCurrency];
    const vpsData = vpsPlans[currentCurrency];

    return (
        <>
            <Helmet>
                <title>{t('titles.home')}</title>
            </Helmet>
            <div className="home-page-wrapper">
                <TopBanner bannerImage={<img src={topBanner} alt="Home banner" />}>
                    <>
                        <h1
                            className="banner-header"
                            dangerouslySetInnerHTML={{ __html: t('home-page.top-banner.title') }}
                        />
                        <h2
                            className="banner-sub-header"
                            dangerouslySetInnerHTML={{ __html: t('home-page.top-banner.text') }}
                        />
                        <ul className="banner-list">
                            <li className="banner-item">
                                <img src={releaseIcon} alt="List item" />
                                <p className="banner-text">{t('home-page.top-banner.list-1')}</p>
                            </li>
                            <li className="banner-item">
                                <img src={releaseIcon} alt="List item" />
                                <p className="banner-text">{t('home-page.top-banner.list-2')}</p>
                            </li>
                            <li className="banner-item">
                                <img src={releaseIcon} alt="List item" />
                                <p className="banner-text">{t('home-page.top-banner.list-3')}</p>
                            </li>
                        </ul>
                        <div className="banner-price">
                            <span className="old-price">{hostingData.year_1.solo}</span>
                            <span className="new-price">{hostingData.year_3.solo}</span>
                            <span className="price-currency">{sign} / month</span>
                        </div>
                        <hr className="banner-separator" />
                        <div className="banner-badges">
                            <span className="single-badge">
                                <img src={startIcon} alt="Star" />
                                {t('titles.free-domain')}
                            </span>
                            <span className="single-badge">
                                <img src={startIcon} alt="Star" />
                                {t('titles.free-ssl')}
                            </span>
                        </div>
                        <div className="banner-actions">
                            <Nav>
                                <SmoothScrollLink to={localizedPath('/hosting/web#plans-section')}>
                                    <Navbar.Brand>{t('buttons.order-hosting')}</Navbar.Brand>
                                </SmoothScrollLink>
                            </Nav>
                            <div className="action-info">
                                <img src={checkmarkIcon} alt="Checkmark" />
                                <p className="action-text">30-Day Money-Back Guarantee</p>
                            </div>
                        </div>
                    </>
                </TopBanner>
                <BottomBanner />
                <section className="section-wrapper services-section">
                    <Container>
                        <div className="section-top">
                            <h2
                                className="section-title"
                                dangerouslySetInnerHTML={{ __html: t('home-page.services-title') }}
                            />
                            <p className="section-text">{t('home-page.services-text')}</p>
                        </div>
                        <Row>
                            <Col lg={4} md={12} xs={12}>
                                <div className="services-card services-card-left active">
                                    <div className="badge-active">
                                        {t('home-page.services-popular')}
                                    </div>
                                    <img
                                        src={webIcon}
                                        alt="Web hosting"
                                        className="services-icon"
                                    />
                                    <h3 className="services-title">
                                        {t('home-page.services-card-1.title')}
                                    </h3>
                                    <p className="services-text">
                                        {t('home-page.services-card-1.text')}
                                    </p>
                                    <div className="services-price">
                                        <p className="price-info">
                                            {t('home-page.services-from')}
                                            <br />
                                            <span className="price-home">
                                                {hostingData.year_3.solo}
                                                <sup>{sign}</sup>
                                            </span>
                                            /{t('home-page.services-month')}
                                        </p>
                                    </div>
                                    <Nav className="common-nav-button">
                                        <SmoothScrollLink
                                            to={localizedPath('/hosting/web#page-top')}
                                        >
                                            <Navbar.Brand>{t('buttons.learn-more')}</Navbar.Brand>
                                        </SmoothScrollLink>
                                    </Nav>
                                </div>
                            </Col>
                            <Col lg={4} md={12} xs={12}>
                                <div className="services-card services-card-middle">
                                    <img
                                        src={emailIcon}
                                        alt="Business Email"
                                        className="services-icon"
                                    />
                                    <h3 className="services-title">
                                        {t('home-page.services-card-2.title')}
                                    </h3>
                                    <p className="services-text">
                                        {t('home-page.services-card-2.text')}
                                    </p>
                                    <div className="services-price">
                                        <p className="price-info">
                                            {t('home-page.services-from')}
                                            <br />
                                            <span className="price-home">
                                                {emailData.year_3.mailpro}
                                                <sup>{sign}</sup>
                                            </span>
                                            /{t('home-page.services-month')}
                                        </p>
                                    </div>
                                    <Nav className="common-nav-button">
                                        <SmoothScrollLink
                                            to={localizedPath(
                                                '/professional-business-email#page-top'
                                            )}
                                        >
                                            <Navbar.Brand>{t('buttons.learn-more')}</Navbar.Brand>
                                        </SmoothScrollLink>
                                    </Nav>
                                </div>
                            </Col>
                            <Col lg={4} md={12} xs={12}>
                                <div className="services-card services-card-right">
                                    <img src={vpsIcon} alt="VPS Server" className="services-icon" />
                                    <h3 className="services-title">
                                        {t('home-page.services-card-3.title')}
                                    </h3>
                                    <p className="services-text">
                                        {t('home-page.services-card-3.text')}
                                    </p>
                                    <div className="services-price">
                                        <p className="price-info">
                                            {t('home-page.services-from')}
                                            <br />
                                            <span className="price-home">
                                                {vpsData.month_12.vps_start}
                                                <sup>{sign}</sup>
                                            </span>
                                            /{t('home-page.services-month')}
                                        </p>
                                    </div>
                                    <Nav className="common-nav-button">
                                        <SmoothScrollLink
                                            to={localizedPath('/vps-server#page-top')}
                                        >
                                            <Navbar.Brand>{t('buttons.learn-more')}</Navbar.Brand>
                                        </SmoothScrollLink>
                                    </Nav>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>
                <section className="section-wrapper search-section">
                    <Container>
                        <div className="section-top">
                            <h2
                                className="section-title"
                                dangerouslySetInnerHTML={{ __html: t('home-page.search-title') }}
                            />
                            <p className="section-text">{t('home-page.search-text')}</p>
                        </div>
                        <div className="domain-search-wrapper">
                            <DomainSearchForm />
                        </div>
                        <div className="domain-tld-prices">
                            <ul>
                                <li>
                                    <span className="domain-tld-style">.com</span> <br />
                                    <span className="price-com">{domainData.com}</span>
                                    <span className="currency">{sign}</span>
                                </li>
                                <li>
                                    <span className="domain-tld-style">.net</span> <br />
                                    <span className="price-net">{domainData.net}</span>
                                    <span className="currency">{sign}</span>
                                </li>
                                <li>
                                    <span className="domain-tld-style">.fr</span> <br />
                                    <span className="price-fr">{domainData.fr}</span>
                                    <span className="currency">{sign}</span>
                                </li>
                                <li>
                                    <span className="domain-tld-style">.be</span> <br />
                                    <span className="price-be">{domainData.be}</span>
                                    <span className="currency">{sign}</span>
                                </li>
                                <li>
                                    <span className="domain-tld-style">.ch</span> <br />
                                    <span className="price-ch">{domainData.ch}</span>
                                    <span className="currency">{sign}</span>
                                </li>
                                <li>
                                    <span className="domain-tld-style">.org</span> <br />
                                    <span className="price-org">{domainData.org}</span>
                                    <span className="currency">{sign}</span>
                                </li>
                            </ul>
                        </div>
                        <Nav className="domain-tld-link">
                            <SmoothScrollLink to={localizedPath('/domain-name#tlds')}>
                                <Navbar.Brand>
                                    <u>{t('buttons.see-tlds')}</u>
                                </Navbar.Brand>
                            </SmoothScrollLink>
                        </Nav>
                    </Container>
                </section>
                <section className="section-wrapper info-section">
                    <Container>
                        <div className="section-top">
                            <h2
                                className="section-title"
                                dangerouslySetInnerHTML={{ __html: t('home-page.info-title') }}
                            />
                            <p className="section-text">{t('home-page.info-text')}</p>
                        </div>
                        <Row>
                            <Col md={6} xs={12}>
                                <div className="info-card">
                                    <Row>
                                        <Col md={2}>
                                            <img
                                                src={infoIcon1}
                                                alt="Web hosting"
                                                className="info-icon"
                                            />
                                        </Col>
                                        <Col md={10}>
                                            <h3 className="info-title">
                                                {t('home-page.info-card-1.title')}
                                            </h3>
                                            <p className="info-text">
                                                {t('home-page.info-card-1.text')}
                                            </p>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                            <Col md={6} xs={12}>
                                <div className="info-card">
                                    <Row>
                                        <Col md={2}>
                                            <img
                                                src={infoIcon2}
                                                alt="Business Email"
                                                className="info-icon"
                                            />
                                        </Col>
                                        <Col md={10}>
                                            <h3 className="info-title">
                                                {t('home-page.info-card-2.title')}
                                            </h3>
                                            <p className="info-text">
                                                {t('home-page.info-card-2.text')}
                                            </p>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                            <Col md={6} xs={12}>
                                <div className="info-card">
                                    <Row>
                                        <Col md={2}>
                                            <img
                                                src={infoIcon3}
                                                alt="VPS Server"
                                                className="info-icon"
                                            />
                                        </Col>
                                        <Col md={10}>
                                            <h3 className="info-title">
                                                {t('home-page.info-card-3.title')}
                                            </h3>
                                            <p className="info-text">
                                                {t('home-page.info-card-3.text')}
                                            </p>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                            <Col md={6} xs={12}>
                                <div className="info-card">
                                    <Row>
                                        <Col md={2}>
                                            <img
                                                src={infoIcon4}
                                                alt="VPS Server"
                                                className="info-icon"
                                            />
                                        </Col>
                                        <Col md={10}>
                                            <h3 className="info-title">
                                                {t('home-page.info-card-4.title')}
                                            </h3>
                                            <p className="info-text">
                                                {t('home-page.info-card-4.text')}
                                            </p>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                            <Col md={6} xs={12}>
                                <div className="info-card">
                                    <Row>
                                        <Col md={2}>
                                            <img
                                                src={infoIcon5}
                                                alt="VPS Server"
                                                className="info-icon"
                                            />
                                        </Col>
                                        <Col md={10}>
                                            <h3 className="info-title">
                                                {t('home-page.info-card-5.title')}
                                            </h3>
                                            <p className="info-text">
                                                {t('home-page.info-card-5.text')}
                                            </p>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                            <Col md={6} xs={12}>
                                <div className="info-card">
                                    <Row>
                                        <Col md={2}>
                                            <img
                                                src={infoIcon6}
                                                alt="VPS Server"
                                                className="info-icon"
                                            />
                                        </Col>
                                        <Col md={10}>
                                            <h3 className="info-title">
                                                {t('home-page.info-card-6.title')}
                                            </h3>
                                            <p className="info-text">
                                                {t('home-page.info-card-6.text')}
                                            </p>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>
                <section className="regular-banner p-5">
                    <h3
                        className="banner-title"
                        dangerouslySetInnerHTML={{ __html: t('banners.regular-banner-text') }}
                    />
                </section>
                <section className="section-wrapper transfer-section">
                    <Container>
                        <div className="section-top">
                            <h2
                                className="section-title"
                                dangerouslySetInnerHTML={{ __html: t('home-page.transfer-title') }}
                            />
                            <p className="section-text">{t('home-page.transfer-text')}</p>
                        </div>
                        <div className="transfer-tabs">
                            <Tabs defaultActiveKey="hosting-plan" id="home-plan-tabs">
                                <Tab
                                    eventKey="hosting-plan"
                                    title={t('home-page.transfer-tab-1.tab-title')}
                                >
                                    <Row>
                                        <Col md={6} className="text-center">
                                            <img
                                                src={migrationIcon}
                                                alt="tab-icons"
                                                className="transfer-image"
                                            />
                                        </Col>
                                        <Col md={6}>
                                            <h2 className="transfer-title">
                                                {t('home-page.transfer-tab-1.content-title')}
                                            </h2>
                                            <p className="transfer-text">
                                                {t('home-page.transfer-tab-1.text')}
                                            </p>
                                            <Nav className="common-nav-button">
                                                <SmoothScrollLink
                                                    to={localizedPath('/hosting/web#plans-section')}
                                                >
                                                    <Navbar.Brand>
                                                        {t('buttons.transfer-hosting')}
                                                    </Navbar.Brand>
                                                </SmoothScrollLink>
                                            </Nav>
                                        </Col>
                                    </Row>
                                </Tab>
                                <Tab
                                    eventKey="domain-name"
                                    title={t('home-page.transfer-tab-2.tab-title')}
                                >
                                    <Row>
                                        <Col md={6} className="text-center">
                                            <img
                                                src={transferDomainIcon}
                                                alt="tab-icons"
                                                className="transfer-image"
                                            />
                                        </Col>
                                        <Col md={6}>
                                            <h2 className="transfer-title">
                                                {t('home-page.transfer-tab-2.content-title')}
                                            </h2>
                                            <p className="transfer-text">
                                                {t('home-page.transfer-tab-2.text')}
                                            </p>
                                            <Nav className="common-nav-button">
                                                <SmoothScrollLink
                                                    to={localizedPath('/domain-name#page-top')}
                                                >
                                                    <Navbar.Brand>
                                                        {t('buttons.transfer-domain')}
                                                    </Navbar.Brand>
                                                </SmoothScrollLink>
                                            </Nav>
                                        </Col>
                                    </Row>
                                </Tab>
                            </Tabs>
                        </div>
                    </Container>
                </section>
                <ContactBanner />
            </div>
        </>
    );
}

export default HomePage;
